module.exports = __webpack_public_path__ + "static/img/banner1.f43617a0.png";